import store from "@/store";
import { ENV } from "@/constants/env";

const CHANNELIO_KEY = {
  dev: "45495ba2-94c6-49f9-abb9-cdd745c61b09",
  qa: "45495ba2-94c6-49f9-abb9-cdd745c61b09",
  prod: "3b76e634-b320-4bc7-912d-aa0f17803a1c",
};

class ChannelService {
  constructor() {}

  loadScript() {
    var w = window;
    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function () {})(
        "ChannelIO script included twice."
      );
    }
    var ch = function () {
      ch.c(arguments);
    };
    ch.q = [];
    ch.c = function (args) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
      s.charset = "UTF-8";
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    }
    if (document.readyState === "complete") {
      l();
    } else if (window.attachEvent) {
      window.attachEvent("onload", l);
    } else {
      window.addEventListener("DOMContentLoaded", l, false);
      window.addEventListener("load", l, false);
    }
  }

  async boot() {
    if (store.state.auth.accessToken) {
      const result =
        store.getters["auth/tokenPayload"]().type === "member"
          ? await store.dispatch("users/biz_member_myInfo")
          : await store.dispatch("users/biz_manager_myInfo");
      const userInfo = result.information;
      ChannelIO("boot", {
        pluginKey: CHANNELIO_KEY[ENV],
        memberId: userInfo.userId,
        profile: {
          name: userInfo.name,
          mobileNumber: userInfo.phoneNumber,
          orderid: null,
          usertype:
            userInfo.memberType == "manager" ? "기업관리자" : "기업구성원",
          lastCheckoutCompletedAt: userInfo.lastOrderAt,
        },
      });
    }
  }

  async updateLastOrderAt(memberType) {
    const result =
      memberType === "member"
        ? await store.dispatch("users/biz_member_myInfo")
        : await store.dispatch("users/biz_manager_myInfo");
    const lastAt = result.information.lastOrderAt;
    ChannelIO("updateUser", {
      profile: {
        lastCheckoutCompletedAt: lastAt,
      },
    });
  }

  updateOrderId(orderId) {
    ChannelIO("updateUser", {
      profile: {
        orderid: orderId,
      },
    });
  }

  updateReferrer(referrer) {
    if (!store.state.auth.accessToken) return;
    ChannelIO("updateUser", {
      profile: {
        referrer: referrer,
      },
    });
  }

  shutdown() {
    window.ChannelIO("shutdown");
  }

  openChat() {
    window.ChannelIO("openChat", undefined, undefined);
  }
}

export default new ChannelService();
